import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
// import {throttle} from 'lodash/throttle';
const throttle = require('lodash/throttle');
// import * as lodash from 'lodash';

import reducers from './reducers';
import errorMiddleware from './errorMiddleware';
import localStoreRedux from './localStoreRedux';

import pickListActions from '../admin/PickList/pickListActions';

const composeEnhancers = composeWithDevTools({});
const middlewares = [
	errorMiddleware(),
	thunk,
];

const configureStore = () => {
	let initialState = localStoreRedux.loadState();
	if (!initialState || !initialState.settings || initialState.settings.version !== process.env.REACT_APP_Version) {
		initialState = {};
	}

	return createStore(reducers, initialState, composeEnhancers(
		applyMiddleware(...middlewares)
	));
	
};

const store = configureStore();

// Hydrations here
store.dispatch(pickListActions.getPickListItems());

// listen to state changes to save back to local storage
store.subscribe(throttle(
	() => {
		const state = store.getState();
		// only save parts of state
		const persistedState = { 
			policy: state.policy, 
			quoting: state.quoting, 
			user: state.user, 
			settings: state.settings 
		};
		localStoreRedux.saveState(persistedState);
	}, 
	1000));

export default store;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/store.ts